var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Card, Typography, getTestId, useBreakpoint, checkIsPlatform, GradientView } from '@airtel/air-design-system';
import { useState } from 'react';
import { View } from 'react-native';
import { CarouselWidget } from '../../../carousel-widget';
import { getOfferCardWidgetStyles } from '../../OfferCardWidgetStyles';
import { SingleOfferCard } from '../single-offer-card';
var DesktopMultiOfferCard = props => {
  var listData = props.listData,
    carouselWidgetProps = props.carouselWidgetProps,
    testID = props.testID,
    restProps = __rest(props, ["listData", "carouselWidgetProps", "testID"]);
  var renderCarouselItem = () => {
    var list = [];
    listData.map((data, id) => {
      list.push(_createElement(SingleOfferCard, Object.assign({}, getTestId(testID + '_listData', id.toString()), data, {
        showShadow: false,
        showRightChevron: false,
        key: 'testimonial_' + id
      }, restProps)));
    });
    return list;
  };
  return _jsx(CarouselWidget, Object.assign({}, getTestId(testID, 'carouselItem'), {
    loop: true,
    slideAnimationDuration: 500,
    data: renderCarouselItem(),
    showIndicators: false,
    indicatorBottomPosition: -32,
    carouselType: "COMPONENT",
    navigationCtaPosition: "relative",
    breakPoints: {
      lg: {
        slidesPerPage: 3,
        slidesToScroll: 1,
        itemSpacing: 24
      }
    },
    showNavigationCtas: (listData === null || listData === void 0 ? void 0 : listData.length) > 3,
    alignment: "center"
  }, carouselWidgetProps));
};
var MobileMultiOfferCard = props => {
  var listData = props.listData,
    carouselWidgetProps = props.carouselWidgetProps,
    _props$parentType = props.parentType,
    parentType = _props$parentType === void 0 ? 'GRADIENT' : _props$parentType,
    _props$gradientType = props.gradientType,
    gradientType = _props$gradientType === void 0 ? 'MANTLE' : _props$gradientType,
    _props$noCardProps = props.noCardProps,
    noCardProps = _props$noCardProps === void 0 ? {} : _props$noCardProps,
    _props$showCard = props.showCard,
    showCard = _props$showCard === void 0 ? true : _props$showCard,
    _props$showShadow = props.showShadow,
    showShadow = _props$showShadow === void 0 ? true : _props$showShadow,
    testID = props.testID,
    restProps = __rest(props, ["listData", "carouselWidgetProps", "parentType", "gradientType", "noCardProps", "showCard", "showShadow", "testID"]);
  var offerWidgetStyles = getOfferCardWidgetStyles(props);
  var _useState = useState(1),
    activeIndex = _useState[0],
    setActiveIndex = _useState[1];
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var renderCarouselItem = () => {
    var list = [];
    listData.map((data, id) => {
      list.push(_createElement(SingleOfferCard, Object.assign({}, getTestId(testID + '_listData', id.toString()), data, {
        showCard: false,
        showRightChevron: false,
        key: 'testimonial_' + id,
        style: {
          borderWidth: 0
        }
      }, restProps)));
    });
    return list;
  };
  var WrapperComponent = parentType === 'GRADIENT' ? GradientView : Card;
  var wrapperProps = parentType === 'GRADIENT' ? {
    type: gradientType
  } : Object.assign(Object.assign({
    noPadding: true
  }, !showCard && noCardProps), {
    showShadow
  });
  return _jsxs(WrapperComponent, Object.assign({
    style: offerWidgetStyles.container
  }, wrapperProps, {
    children: [_jsx(View, Object.assign({
      style: {
        flex: 1,
        display: 'flex'
      }
    }, {
      children: _jsx(CarouselWidget, Object.assign({}, getTestId(testID, 'carouselItem'), {
        loop: true,
        autoPlayTransitionSpeed: 3200,
        slideAnimationDuration: 800,
        data: renderCarouselItem(),
        showIndicators: false,
        carouselType: "COMPONENT",
        onSlideChangeHandler: index => {
          setActiveIndex(parseInt(index) + 1);
        },
        breakPoints: {
          xs: {
            slidesPerPage: 1,
            slidesToScroll: 1
          }
        }
      }, carouselWidgetProps))
    })), _jsx(View, Object.assign({
      style: offerWidgetStyles.rightCounter
    }, checkIsPlatform('web') && {
      'aria-hidden': true
    }, {
      children: _jsx(Typography, Object.assign({}, getTestId(testID, 'rightCounter'), {
        color: "BLUE_500",
        multiText: [{
          text: "" + activeIndex,
          type: "body-single-line-" + (isLargeScreen ? 'md' : 'sm') + "-bold"
        }, {
          text: "/" + (listData === null || listData === void 0 ? void 0 : listData.length),
          type: "body-single-line-" + (isLargeScreen ? 'sm' : 'xs')
        }]
      }))
    }))]
  }));
};
export var MultiOfferCard = props => {
  var _props$keepMobileView = props.keepMobileViewInDesktop,
    keepMobileViewInDesktop = _props$keepMobileView === void 0 ? false : _props$keepMobileView;
  var _useBreakpoint2 = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint2.isSmallScreen;
  return _jsx(_Fragment, {
    children: isSmallScreen || keepMobileViewInDesktop ? _jsx(MobileMultiOfferCard, Object.assign({}, getTestId((props === null || props === void 0 ? void 0 : props.testID) + '_mobileOfferCard'), props)) : _jsx(DesktopMultiOfferCard, Object.assign({}, getTestId((props === null || props === void 0 ? void 0 : props.testID) + '_desktopOfferCard'), props))
  });
};